module.exports = __webpack_public_path__ + "static/media/insta-17.76a86bbe.png";